<sidenav [orientation]="orientation" [ngClass]="getClasses()">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" *ngIf="orientation !== 'horizontal'">
        <span class="app-brand-logo demo">

      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" width="256px" height="256px" viewBox="0 0 256 256" enable-background="new 0 0 256 256"
        xml:space="preserve">
        <path fill="#FFFFFF" d="M253.725,127.805c0,69.443-56.283,125.735-125.724,125.735c-69.438,0-125.726-56.292-125.726-125.735
     C2.275,58.38,58.563,2.09,128.001,2.09C197.439,2.09,253.725,58.38,253.725,127.805z" />
        <g>
          <path fill="none" stroke="#000000" stroke-width="14" stroke-miterlimit="10" d="M167.658,123H87.984v-21.931
       c0-14.271,3.27-25.052,9.807-32.343c6.538-7.291,16.196-10.936,28.975-10.936c6.148,0,11.742,1.018,16.779,3.054
       c5.037,2.036,9.344,4.973,12.918,8.813c3.576,3.839,6.334,8.493,8.279,13.961c1.943,5.468,2.916,11.634,2.916,18.498V123z
        M94.763,115.263h66.172v-12.797c0-5.739-0.74-10.868-2.224-15.386c-1.479-4.517-3.655-8.347-6.526-11.488
       c-2.869-3.142-6.418-5.536-10.642-7.184c-4.224-1.648-9.073-2.472-14.558-2.472c-21.483,0-32.226,11.887-32.226,35.658
       L94.763,115.263L94.763,115.263z" />
        </g>
        <g>
          <rect x="80.966" y="144.367" width="93.71" height="21.581" />
          <rect x="117.209" y="165.948" width="21.582" height="38.219" />
        </g>
      </svg>

    </span>
        <a routerLink="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">{{ 'menu.dant' | translate }}</a>
        <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" (click)="toggleSidenav()">
            <i class="ion ion-md-menu align-middle"></i>
        </a>
    </div>

    <div class="sidenav-divider mt-0" *ngIf="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div class="sidenav-inner" [ngClass]="{ 'py-1': orientation !== 'horizontal' }">

        <sidenav-header class="small font-weight-semibold">{{ user ? user.nomeCliente : '' }}</sidenav-header>

        <sidenav-divider *ngIf="isShowPessoas()" class="mb-1"></sidenav-divider>

        <sidenav-header class="small font-weight-semibold">{{ 'menu.consultas' | translate }}</sidenav-header>

        <!-- Busca rápida -->
        <sidenav-router-link *ngIf="hasDic(Dicionario.BUSCA_RAPIDA)" icon="ion ion-ios-search" route="/search" [active]="isActive('/search')">
            {{ 'menu.pesquisar' | translate }}</sidenav-router-link>

        <sidenav-router-link *ngIf="hasDic(Dicionario.HISTORICO)" icon="ion ion-ios-swap" route="/search/history" [active]="isActive('/search/history')">
            {{ 'menu.historico' | translate }}</sidenav-router-link>
        <sidenav-router-link *ngIf="hasDic(Dicionario.VEICULO)" icon="ion ion-ios-car" route="/search/vehicle/list" [active]="isActive('/search/vehicle/list')">
            {{ 'menu.veiculo' | translate }}</sidenav-router-link>
        <sidenav-router-link *ngIf="hasDic(Dicionario.REFEITORIO)" icon="ion ion-md-restaurant" route="/search/refectory/list" [active]="isActive('/search/refectory/list')">
            {{ 'menu.refeitorio' | translate }}</sidenav-router-link>
        <sidenav-router-link *ngIf="hasDic(Dicionario.HISTORICO)" icon="far fa-address-card" route="/search/manualaccess/list" [active]="isActive('/search/manualaccess/list')">
            {{ 'menu.acesso_manual' | translate }}</sidenav-router-link>

        <sidenav-divider *ngIf="isShowPessoas()" class="mb-1"></sidenav-divider>
        <sidenav-header *ngIf="isShowPessoas()" class="small font-weight-semibold">{{ 'menu.cadastros' | translate }}
        </sidenav-header>
        <sidenav-menu *ngIf="isShowPessoas()" icon="ion ion-md-people" text="{{ 'menu.pessoas' | translate }}" [active]="isMenuActive('/people')" [open]="isMenuOpen('/people')">

            <sidenav-router-link route="/people/visitor/list" [active]="isActive2('/people/visitor/list', 'perfil=1')" *ngIf="hasDic(Dicionario.VISITANTE)">
                {{ 'menu.visitante' | translate }}
            </sidenav-router-link>
            <sidenav-router-link route="/people/homeowner/list" [active]="isActive2('/people/homeowner/list', 'perfil=3')" *ngIf="hasDic(Dicionario.MORADOR)">
                {{ 'menu.morador' | translate }}
            </sidenav-router-link>
            <sidenav-router-link route="/people/staff/list" [active]="isActive2('/people/staff/list', 'perfil=2')" *ngIf="hasDic(Dicionario.FUNCIONARIO)">
                {{ 'menu.funcionario' | translate }}
            </sidenav-router-link>
            <sidenav-router-link route="/people/student/list" [active]="isActive2('/people/student/list', 'perfil=4')" *ngIf="hasDic(Dicionario.ALUNO)">
                {{ 'menu.aluno' | translate }}
            </sidenav-router-link>
            <sidenav-router-link route="/people/user/list" [active]="isActive2('/people/user')" *ngIf="hasDic(Dicionario.CONTA_DE_USUARIO)">
                {{ 'menu.conta' | translate }}
            </sidenav-router-link>
            <sidenav-router-link route="/people/customer/list" [active]="isActive2('/people/customer')" *ngIf="hasDic(Dicionario.CLIENTE)">{{ 'menu.cliente' | translate }}
            </sidenav-router-link>
        </sidenav-menu>

        <!-- <ng-container *ngIf="isShowEstoque()"> -->
        <ng-container *ngIf="false">
            <sidenav-divider class="mb-1"></sidenav-divider>
            <sidenav-header class="small font-weight-semibold">{{ 'ARMÁRIOS' | translate }}</sidenav-header>
            <sidenav-router-link route="/stock/monitor-stock/list" [active]="isActive2('/stock/monitor-stock')" *ngIf="hasDic(Dicionario.ESTOQUE)">{{ 'Armários' | translate }}
            </sidenav-router-link>

            <!-- <sidenav-router-link route="/dashboards/dashboard-stock" [active]="isActive2('/dashboards/dashboard-stock')">
               Dashboard
           </sidenav-router-link> -->
            <sidenav-menu text="{{ 'Cadastros' | translate }}" [active]="isMenuActive('/stock/r', true)" [open]="isMenuOpen('/stock/r', true)" *ngIf="hasDic(Dicionario.RELATORIO_DE_ACESSO)">
                <sidenav-router-link route="/stock/r/product/list" [active]="isActive2('/stock/r/product')" *ngIf="hasDic(Dicionario.PRODUTO)">{{ 'Produtos' | translate }}
                </sidenav-router-link>
            </sidenav-menu>

            <sidenav-menu text="{{ 'Relatórios' | translate }}" [active]="isMenuActive('/reports/stock', true)" [open]="isMenuOpen('/reports/stock', true)" *ngIf="hasDic(Dicionario.RELATORIO_DE_ACESSO)">
                <sidenav-router-link route="/reports/stock/pending-users" [active]="isActive2('/reports/stock/pending-users')">
                    {{ 'Usuários com Pendência' | translate }}
                </sidenav-router-link>
                
                <sidenav-router-link route="/reports/stock/product-tag-history" [active]="isActive2('/reports/stock/product-tag-history')">
                    {{ 'Histórico de Movimentações' | translate }}
                </sidenav-router-link>
            </sidenav-menu>

            <sidenav-menu text="{{ 'Avançados' | translate }}" [active]="isMenuActive('stock/a', true)" [open]="isMenuOpen('stock/a', true)" *ngIf="hasDic(Dicionario.RELATORIO_DE_ACESSO)">
                <sidenav-router-link route="/stock/a/stock/list" [active]="isActive2('/stock/a/stock')" *ngIf="hasDic(Dicionario.ESTOQUE)">{{ 'Cadastro de armários' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/stock/a/users" [active]="isActive2('/stock/a/users')">
                    {{ 'Relatório de Usuários' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/stock/a/product-tag/list" [active]="isActive2('/stock/a/product-tag/')" *ngIf="hasDic(Dicionario.PRODUTO)">{{ 'Relatório de Produtos' | translate }}
                </sidenav-router-link>
                
            </sidenav-menu>
        </ng-container>

        <sidenav-divider class="mb-1"></sidenav-divider>
        <sidenav-header class="small font-weight-semibold">{{ 'menu.comunicacao' | translate }}</sidenav-header>
        <sidenav-router-link route="/communication/order-notice/list" icon="fas fa-box-open" [active]="isActive2('/communication/order-notice/list')">

            <div>{{ 'menu.encomenda' | translate }}</div>

        </sidenav-router-link>
        <sidenav-router-link route="/pages/chat" icon="fab fa-rocketchat" [active]="isActive2('/pages/chat')" *ngIf="hasDic(Dicionario.CHAT) && false">

            <div>{{ 'menu.chat' | translate }}
            </div>

        </sidenav-router-link>
        <sidenav-router-link route="/pages/chat" icon="fab fa-book" [active]="isActive2('/pages/chat')" *ngIf="hasDic(Dicionario.CHAT) && false">
            <div>{{ 'menu.evento' | translate }}
            </div>
        </sidenav-router-link>

        <sidenav-router-link icon="ion ion-ios-calendar" route="/area-reservation/list" [active]="isActive2('/area-reservation/list')" *ngIf="hasDic(Dicionario.LOCAL_EVENTO)">
            {{ 'menu.area_reservation' | translate }}
        </sidenav-router-link>

        <sidenav-divider class="mb-1"></sidenav-divider>
        <sidenav-header class="small font-weight-semibold">{{ 'menu.centro_ajuda' | translate }}</sidenav-header>

        <sidenav-router-link route="/help" icon="fas fa-video" [active]="isActive2('/help')">
            <div>{{ 'menu.video_guia' | translate }}
            </div>
        </sidenav-router-link>


        <sidenav-divider *ngIf="isShowRelatorios()" class="mb-1"></sidenav-divider>

        <!-- Reports -->
        <sidenav-menu icon="ion ion-md-document" text="{{ 'menu.relatorios' | translate }}" [active]="isMenuActive('/reports')" [open]="isMenuOpen('/reports')" *ngIf="isShowRelatorios()">

            <sidenav-menu text="{{ 'menu.acessos' | translate }}" [active]="isMenuActive('/reports/access')" [open]="isMenuOpen('/reports/access')" *ngIf="hasDic(Dicionario.RELATORIO_DE_ACESSO)">

                <sidenav-router-link route="/reports/access/history" [active]="isActive2('/reports/access/history')">
                    {{ 'menu.relatorio.historico' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/access/audit" [active]="isActive2('/reports/access/audit')">
                    {{ 'menu.relatorio.auditoria' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/access/card" [active]="isActive2('/reports/access/card')">
                    {{ 'menu.relatorio.cartao' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/access/command" [active]="isActive2('/reports/access/command')">
                    {{ 'menu.relatorio.comando' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/access/login" [active]="isActive2('/reports/access/login')">
                    {{ 'menu.relatorio.login' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/access/blocked" [active]="isActive2('/reports/access/blocked')">
                    {{ 'menu.relatorio.bloqueio' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/access/refectory" [active]="isActive2('/reports/access/refectory')">
                    {{ 'menu.relatorio.refeicao' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/access/infrequent" [active]="isActive2('/reports/access/infrequent')">
                    {{ 'menu.relatorio.acesso_infrequente' | translate }}
                </sidenav-router-link>
            </sidenav-menu>

            <sidenav-menu text="{{ 'menu.cadastrais' | translate }}" [active]="isMenuActive('/reports/registrations')" [open]="isMenuOpen('/reports/registrations')" *ngIf="hasDic(Dicionario.RELATORIO_CADASTRAL)">
                <sidenav-router-link route="/reports/registrations/card" [active]="isActive2('/reports/registrations/card')">
                    {{ 'menu.relatorio.cartao' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/registrations/people" [active]="isActive2('/reports/registrations/people')">
                    {{ 'menu.relatorio.pessoa' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/registrations/phone" [active]="isActive2('/reports/registrations/phone')">
                    {{ 'menu.relatorio.telefone' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/registrations/vehicle" [active]="isActive2('/reports/registrations/vehicle')">
                    {{ 'menu.relatorio.veiculo' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/registrations/visitor" [active]="isActive2('/reports/registrations/visitor')">
                    {{ 'menu.relatorio.visitante' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/registrations/local" [active]="isActive2('/reports/registrations/local')">
                    {{ 'menu.relatorio.localpessoas' | translate }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/registrations/objeto" [active]="isActive2('/reports/registrations/objeto')">
                    {{ 'menu.relatorio.objeto' | translate }}
                </sidenav-router-link>
            </sidenav-menu>

            <sidenav-menu text="{{ 'menu.estatisticas' | translate }}" [active]="isMenuActive('/reports/estatisticas')" [open]="isMenuOpen('/reports/estatisticas')" *ngIf="hasDic(Dicionario.RELATORIO_ESTATISTICA)">
                <sidenav-router-link route="/reports/estatisticas/tag_setor" [active]="isActive2('/reports/estatisticas/tag_setor')">
                    {{ 'menu.relatorio.tag_setor' | translate:{'value': translateSetor.toLowerCase() } }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/estatisticas/tag_empresa" [active]="isActive2('/reports/estatisticas/tag_empresa')">
                    {{ 'menu.relatorio.tag_empresa' | translate:{'value': translateEmpresa.toLowerCase() } }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/estatisticas/qtd_pessoa_empresa" [active]="isActive2('/reports/estatisticas/qtd_pessoa_empresa')">
                    {{ 'menu.relatorio.qtd_pessoa_empresa' | translate:{'value': translateEmpresa.toLowerCase() } }}
                </sidenav-router-link>
                <sidenav-router-link route="/reports/estatisticas/qtd_pessoa_setor" [active]="isActive2('/reports/estatisticas/qtd_pessoa_setor')">
                    {{ 'menu.relatorio.qtd_pessoa_setor' | translate:{'value': translateSetor.toLowerCase() } }}
                </sidenav-router-link>
            </sidenav-menu>

            <sidenav-router-link route="/reports/unidades_ocupadas" [active]="isActive2('/reports/unidades_ocupadas')">
                {{'menu.unidades_ocupadas' | translate}}
            </sidenav-router-link>

            <sidenav-router-link route="/reports/vagas_ocupadas" [active]="isActive2('/reports/vagas_ocupadas')">
                <div>{{'menu.vagas_ocupadas' | translate}}
                    <div class="badge badge-primary ml-2">Novo</div>
                </div>
            </sidenav-router-link>

        </sidenav-menu>


        <sidenav-divider class="mb-1"></sidenav-divider>

        <!-- Dashboards -->
        <sidenav-menu icon="ion ion-md-speedometer" text="{{ 'menu.dashboards' | translate }}" [active]="isMenuActive('/dashboards')" [open]="isMenuOpen('/dashboards')">
            <sidenav-router-link route="/dashboards/dashboard-2" [active]="isActive2('/dashboards/dashboard-2')">Acesso
            </sidenav-router-link>

            <sidenav-router-link *ngIf="mostrarServico" route="/dashboards/dashboard-refeitorio" [active]="isActive2('/dashboards/dashboard-refeitorio')">Refeitório
            </sidenav-router-link>

            <sidenav-router-link route="/dashboards/dashboard-ocupacao" [active]="isActive2('/dashboards/dashboard-ocupacao')">
                Ocupação</sidenav-router-link>

        </sidenav-menu>


        <sidenav-divider class="mb-1" *ngIf="isShowConfiguracoes()"></sidenav-divider>
        <sidenav-header class="small font-weight-semibold" *ngIf="isShowConfiguracoes()">
            {{ 'menu.configuracoes' | translate }}</sidenav-header>

        <sidenav-router-link *ngIf="hasDic(Dicionario.DISPOSITIVO) && isShowConfiguracoes()" icon="ion ion-md-quote" route="/config/device/list" [active]="isActive2('/config/device')">
            {{ 'menu.dispositivo' | translate }}
        </sidenav-router-link>

        <!-- Config -->
        <sidenav-menu icon="ion ion-ios-construct" text="{{ 'menu.outros' | translate }}" [active]="isMenuActive('/config') && !isActive2('/config/device')  && !isActive2('/config/import')" [open]="isMenuOpen('/config') && !isActive2('/config/device') && !isActive2('/config/import')"
            *ngIf="isShowConfiguracoes()">
            <sidenav-router-link *ngIf="hasDic(Dicionario.EMPRESA)" route="/config/company/list" [active]="isActive2('/config/company')">
                {{ translateEmpresa + 's' }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.TAG)" route="/config/card/list" [active]="isActive2('/config/card')">
                {{ 'menu.cartao' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.FORNECEDOR)" route="/config/supplier/list" [active]="isActive2('/config/supplier')">
                {{ 'menu.fornecedor' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.TIPO_COMANDO)" route="/config/typecommand/list" [active]="isActive2('/config/typecommand')">
                {{ 'menu.tipo_comando' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.HORARIO)" route="/config/timetable/list" [active]="isActive2('/config/timetable')">
                {{ 'menu.horario' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.LOCAL_DE_ACESSOS)" route="/config/local/list" [active]="isActive2('/config/local')">
                {{ 'menu.local_acesso' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.MOTIVO)" route="/config/motive/list" [active]="isActive2('/config/motive')">
                {{ 'menu.motivo' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.PERFIL_DE_ACESSO)" route="/config/accessprofile/list" [active]="isActive2('/config/accessprofile')">
                {{ 'menu.perfil_de_acesso' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.GRUPO)" route="/config/groupaccount/list" [active]="isActive2('/config/groupaccount')">
                {{ 'menu.grupo' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.CONFIGURACAO_SISTEMA)" route="/config/system/edit" [active]="isActive2('/config/system/edit')">
                {{ 'menu.sistema' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.LOCAL_EVENTO)" route="/config/area/list" [active]="isActive2('/config/area/list')">
                {{ 'menu.area' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.BLOQUEIO_LOCAL)" route="/config/areablock/list" [active]="isActive2('/config/areablock/list')">
                {{ 'menu.area_block' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.OPERADORA)" route="/config/operadora/list" [active]="isActive2('/config/operadora')">
                {{ 'menu.operadora' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.TIPO_SERVICO)" route="/config/tiposervico/list" [active]="isActive2('/config/tiposervico')">
                {{ 'menu.tipo_servico' | translate }}</sidenav-router-link>
            <sidenav-router-link *ngIf="hasDic(Dicionario.EVENTO)" route="/config/reservation/list" [active]="isActive2('/config/areablock/list')">
                {{ 'Tipos de evento' | translate }}</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu *ngIf="isShowImportacao()" icon="ion ion-ios-cloud-upload" text="{{ 'menu.importacao' | translate }}" [active]="isMenuActive('/config/import')" [open]="isMenuOpen('/config/import')">
            <sidenav-router-link *ngIf="hasDic(Dicionario.IMPORTACAO_FUNCIONARIO)" route="/config/import/people" [active]="isActive2('/config/import/people')">
                {{ 'menu.pessoas' | translate }}</sidenav-router-link>
        </sidenav-menu>


        <sidenav-divider class="mb-1"></sidenav-divider>


    </div>
</sidenav>